module.exports = __webpack_public_path__ + "assets/img/1.2385e5ca.jpg";